import { useEffect, useRef, useState } from "react";

import { BADGE_PULSE_RESET_MS } from "../constant";

export const useBadgePulse = (count: number): boolean => {
  const [isPulsing, setIsPulsing] = useState(false);
  const previousCountRef = useRef(count);
  const pulseTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (count > previousCountRef.current) {
      setIsPulsing(true);
      if (pulseTimeoutRef.current) {
        clearTimeout(pulseTimeoutRef.current);
      }
      pulseTimeoutRef.current = window.setTimeout(() => {
        setIsPulsing(false);
      }, BADGE_PULSE_RESET_MS);
    }

    previousCountRef.current = count;
  }, [count]);

  useEffect(() => {
    return () => {
      if (pulseTimeoutRef.current) {
        clearTimeout(pulseTimeoutRef.current);
      }
    };
  }, []);

  return isPulsing;
};
